import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { ClientDataService } from '../../data-services/client.service';
import { LookupService } from '../../data-services/lookup.service';
import { SelectItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { ProviderAddComponent } from '../../modules/provider/provider.add';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FacilityAddComponent } from "../facility/facility.add";
import { FormsModule } from '@angular/forms';
import { Toast } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { HasClaimDirective } from '../../security/has-claim.directive';

@Component({
  selector: 'app-client-edit',
  templateUrl: './client.edit.html',
  styleUrls: ['./client.edit.css'],
  providers: [MessageService, DialogService],
  imports: [FormsModule, Toast, CommonModule, SelectModule, HasClaimDirective]
})
export class ClientEditComponent implements OnInit {
  @Output() operationComplete = new EventEmitter<string>();

  constructor(private clientDataService: ClientDataService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private cdRef: ChangeDetectorRef,
    private lookupService: LookupService,
    private messageService: MessageService,
    public dialogService: DialogService) {
  }


  public id: number = 0;
  loading: boolean;
  states: SelectItem[];
  editmode: boolean = false;
  client: any = {};
  options = {
    componentRestrictions: {
      country: ["US"]
    }
  } 
  processingTypes: SelectItem[] = [];

  ngOnInit() {
    this.loading = true;
    this.lookupService.getStates().subscribe((data: any) => {
      this.states = data.map(d => <SelectItem>{ label: d.Description, value: d.Code });
      this.loading = false;
    });
    this.processingTypes = [
      { label: '', value: '' },
      { label: 'Fully Electronic', value: '1' },
      { label: 'Electronic Orders', value: '2' },
      { label: 'Paper Requisitions', value: '3' }
    ];
    this.id = this.config.data.id;

    this.getClient(this.id);

  }

  public getClient(clientid) {
    this.id = clientid;

    if (this.id == 0) {
      this.clientDataService.getEmptyModel().subscribe((data: any) => {
        this.client = data;
        this.client.LabId = 1;
        this.client.ProcessingTypeLabel = this.processingTypes.filter(x => x.value == this.client.ProcessingType)[0].label;
        this.editmode = true;
        this.cdRef.detectChanges();
        this.client.Providers = [];
        this.client.Facilities = [];
        this.loading = false;
      });
    }
    else {
      this.clientDataService.getById(this.id).subscribe((data: any) => {
        this.client = data;
        this.client.ProcessingTypeLabel = this.processingTypes.filter(x => x.value == this.client.ProcessingType)[0].label;
        this.cdRef.detectChanges();
        this.loading = false;
      });
    }
  }

  public saveClient() {
    this.loading = true;
    this.clientDataService.save(this.client).subscribe((data: any) => {
      this.messageService.add({ severity: 'success', summary: 'Client Saved', detail: `Saved client [${this.client.Name}]` });
      this.saveComplete();
      this.loading = false;
    });
  }

  saveComplete() {
    this.editmode = false;
    this.operationComplete.emit('saved');
  }

  processingTypeOnChange() {
    this.client.ProcessingTypeLabel = this.processingTypes.filter(x => x.value == this.client.ProcessingType)[0].label;
  }


  public toggleEdit() {
    this.editmode = !this.editmode;
  }

  public addProvider() {
    const ref = this.dialogService.open(ProviderAddComponent, {
      header: 'Find a provider to add',
      width: '750px',
      height: '500px'
    });

    ref.onClose.subscribe((provider: any) => {
      if (provider) {
        this.client.Providers.push(provider);
      }
    });
  }

  public removeProvider(i) {
    this.client.Providers.splice(i, 1);
  }

  public addFacility() {
    const ref = this.dialogService.open(FacilityAddComponent, {
      header: 'Find a facility to add',
      width: '750px',
      height: '500px'
    });

    ref.onClose.subscribe((facility: any) => {
      if (facility) {
        this.client.Facilities.push(facility);
      }
    });
  }

  public removeFacility(i) {
    this.client.Facilities.splice(i, 1);
  }

  public AddressChange(address: any) {
    //setting address from API to local variable 
    this.client.Address1 = this.getAddressPart(address, 'l', 'street_number') + ' ' + this.getAddressPart(address, 'l', 'route');
    this.client.City = this.getAddressPart(address, 'l', 'locality');
    if (!this.client.City) {
      this.client.City = this.getAddressPart(address, 'l', 'neighborhood');
    }
    if (!this.client.City) {
      this.client.City = this.getAddressPart(address, 'l', 'sublocality');
    }
    this.client.State = this.getAddressPart(address, 's', 'administrative_area_level_1');
    this.client.ZipCode = this.getAddressPart(address, 's', 'postal_code');
  }

  private getAddressPart(data, part, key) {
    for (var i = 0; i < data.address_components.length; i++) {
      if (data.address_components[i].types.includes(key)) {
        if (part == 'l') {
          return data.address_components[i].long_name;
        } else {
          return data.address_components[i].short_name;
        }
      }
    }
    return '';
  }
}
